import React from "react";
import Image from "next/image";
import styles from "../../styles/shap_of_you.module.scss";
import WelcomeScreenImg from "../../assets/images/WelcomeScreen_dek.png";
import SOYLockUp from "../../assets/images/spl.png";
import { DesktopNavigationProps } from "./types";

const WelcomeScreen: React.FC<DesktopNavigationProps> = ({ navigateToStep }) => {
  return (
    <div className="d-none d-md-block w-100">
      <div className={styles.desktop_view_shap_welcome}>
        <div className={styles.bgImage}>
          <Image src={WelcomeScreenImg} alt="Welcome Screen" />
        </div>
        <div className={styles.shapeOfYou}>
          <div className={styles.content}>
            <div className={styles.title}>
              <Image src={SOYLockUp} alt="Shape of You Logo" />
            </div>
          </div>
          <div className={styles.button_cont}>
            <button
              className={styles.ctaBtn}
              onClick={() => navigateToStep("uploadOrScan")}
            >
              Start Experience →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
